import React from "react";
import Logo from '../assets/images/Mr-Chap.png'
import { Card, Row, Col, Typography, Divider, Button, Tag } from 'antd';
import { 
  CheckCircleOutlined, 
  TeamOutlined, 
  FlagOutlined, 
  HeartOutlined, 
  CustomerServiceOutlined,
  GiftOutlined,
  PrinterOutlined,
  ShoppingOutlined,
  GlobalOutlined,
  TrophyOutlined,
  StarOutlined,
  SafetyOutlined,
  ThunderboltOutlined,
  ArrowRightOutlined,
  PlayCircleOutlined,
  CalendarOutlined,
  UserOutlined,
  ShoppingCartOutlined
} from '@ant-design/icons';

const { Title, Paragraph, Text } = Typography;

const AboutUs = () => {
  // Statistics data with gradients matching why choose us
  const stats = [
    { number: "۷+", label: "سال تجربه", icon: <CalendarOutlined />, gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)", color: "white" },
    { number: "۱۰,۰۰۰+", label: "مشتری راضی", icon: <UserOutlined />, gradient:"linear-gradient(135deg, #a23854 0%, #c74b6e 100%)" , color: "white" },
    { number: "۵۰,۰۰۰+", label: "محصول چاپ شده", icon: <ShoppingCartOutlined />, gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)", color: "white" },
    { number: "۲۴/۷", label: "پشتیبانی", icon: <CustomerServiceOutlined />, gradient: "linear-gradient(135deg, #a23854 0%, #c74b6e 100%)", color: "white" },
  ];

  // Services data with better icons
  const services = [
    { title: "چاپ تیشرت حرفه‌ای", description: "تیشرت نخی، اسپرت، فانتزی، زنانه، مردانه و بچگانه با بالاترین کیفیت چاپ", icon: <ShoppingOutlined /> },
    { title: "چاپ ماگ اختصاصی", description: "ماگ‌های سرامیکی ممتاز، حرارتی و طرح‌دار با ماندگاری عالی", icon: <GiftOutlined /> },
    { title: "چاپ عکس و طرح دلخواه", description: "چاپ هر نوع طرح، عکس، لوگو و متن با دقت و ظرافت بی‌نظیر", icon: <PrinterOutlined /> },
    { title: "هدایای تبلیغاتی برند", description: "تولید هدایای اختصاصی با چاپ لوگو و طرح برند شما برای معرفی کسب‌وکارتان", icon: <TeamOutlined /> },
  ];

  // Why choose us - with gradient backgrounds
  const whyChooseUs = [
    { title: "کیفیت ماندگار", description: "استفاده از بهترین دستگاه‌های چاپ روز دنیا با مرغوب‌ترین مواد اولیه", icon: <SafetyOutlined />, gradient: "linear-gradient(135deg, #a23854 0%, #c74b6e 100%)" },
    { title: "قیمت مناسب", description: "ارائه بهترین قیمت در بازار با تضمین بالاترین کیفیت چاپ", icon: <FlagOutlined />, gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)" },
    { title: "تحویل سریع", description: "تولید و ارسال سفارشات در کوتاه‌ترین زمان ممکن با بسته‌بندی حرفه‌ای", icon: <ThunderboltOutlined />, gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)" },
    { title: "پشتیبانی کامل", description: "مشاوره رایگان تخصصی قبل و بعد از سفارش برای اطمینان از نتیجه نهایی", icon: <CustomerServiceOutlined />, gradient: "linear-gradient(135deg, #a23854 0%, #c74b6e 100%)"  },
  ];

  // Timeline data for the story section
  const timelineEvents = [
    { year: "۱۳۹۹", title: "شروع فعالیت", description: "آغاز به کار مجموعه آقای چاپ با هدف ارائه خدمات چاپ سفارشی با کیفیت بالا", icon: <StarOutlined /> },
    { year: "۱۴۰۰", title: "توسعه خدمات", description: "افزایش تنوع محصولات و اضافه شدن چاپ روی ماگ، هودی و دورس", icon: <FlagOutlined /> },
    { year: "۱۴۰۳", title: "افتخار مشتریان", description: "عبور از مرز 5,000 مشتری راضی و گسترش تیم حرفه‌ای", icon: <HeartOutlined /> },
    { year: "۱۴۰۴", title: "پیشرو در صنعت", description: "استفاده از پیشرفته‌ترین دستگاه‌های چاپ روز دنیا", icon: <TrophyOutlined /> },
  ];

  return (
    <div style={{ direction: 'rtl', fontFamily: 'Yekan, IRANSans, Tahoma, sans-serif' }}>
      <Row justify="center" style={{ padding: "20px 0" }}>
        <Col xs={24} sm={22} md={20} lg={18} xl={16} xxl={14}>
          
          {/* Hero Section with Glass Effect */}
          <Card 
            className="light-glass-effect-card shaped-border"
            style={{ 
              marginBottom: 32,
              background: "linear-gradient(135deg, rgba(162,56,84,0.15) 0%, rgba(255,255,255,0.05) 100%)",
              border: "1px solid rgba(162,56,84,0.2)",
              backdropFilter: "blur(10px)"
            }}
          >
            <Row align="middle" gutter={[32, 32]}>
              <Col xs={24} md={12}>
                <div style={{ textAlign: "center" }}>
                  <div style={{ 
                    width: 120, 
                    height: 120, 
                    margin: "0 auto 20px",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}>
                    <img src={Logo} width={180} height={180} alt="Mr Chap Logo" />
                  </div>

                  <Text style={{ fontSize: 16, color: '#4a4a4a', fontFamily: 'Yekan' }}>
                    حرفه‌ای‌ترین مرجع چاپ سفارشی در ایران
                  </Text>
                </div>
              </Col>
              <Col xs={24} md={12}>
                <div style={{ padding: "10px" }}>
                  <Title level={3} style={{ color: '#a23854', fontFamily: 'Yekan', marginBottom: 16 }}>
                    به خانواده آقای چاپ خوش آمدید
                  </Title>
                  <Paragraph style={{ fontSize: 15, lineHeight: 1.9, textAlign: "justify", fontFamily: 'Yekan', color: '#4a4a4a' }}>
                    ما در مجموعه‌ی خود با سال‌ها تجربه در زمینه چاپ تیشرت، چاپ ماگ و تولید هدایای تبلیغاتی و 
                    شخصی‌سازی‌شده فعالیت می‌کنیم. هدف ما ارائه خدمات حرفه‌ای با بهترین کیفیت چاپ و مناسب‌ترین 
                    قیمت است تا هر مشتری بتواند طرح دلخواه خود را روی محصول مورد نظرش ثبت کند.
                  </Paragraph>
                </div>
              </Col>
            </Row>
          </Card>



          {/* Mission Section */}
          <Card 
            className="shaped-border"
            style={{ 
              marginBottom: 32,
              background: "linear-gradient(135deg, #a23854 0%, #ba4c6e 50%, #d4718f 100%)",
              border: "none",
              position: "relative",
              overflow: "hidden"
            }}
          >
            <div style={{ 
              position: "absolute", 
              top: -50, 
              right: -50, 
              width: 150, 
              height: 150, 
              background: "rgba(255,255,255,0.1)", 
              borderRadius: "50%" 
            }} />
            <div style={{ 
              position: "absolute", 
              bottom: -70, 
              left: -70, 
              width: 200, 
              height: 200, 
              background: "rgba(255,255,255,0.05)", 
              borderRadius: "50%" 
            }} />
            
            <Row justify="center" align="middle" style={{ position: "relative", zIndex: 1 }}>
              <Col span={24} style={{ textAlign: "center", padding: "40px 20px" }}>
                <FlagOutlined style={{ fontSize: 52, marginBottom: 16, color: "white" }} />
                <Title level={3} style={{ color: "white", fontFamily: 'Yekan', marginBottom: 16 }}>
                  ماموریت ما
                </Title>
                <Paragraph style={{ fontSize: 18, color: "rgba(255,255,255,0.95)", maxWidth: 700, margin: "0 auto", fontFamily: 'Yekan' }}>
                  کمک کنیم ایده‌های شما به یک محصول زیبا، خاص و ماندگار تبدیل شوند. با ما می‌توانید بهترین تجربه 
                  چاپ سفارشی را داشته باشید.
                </Paragraph>
              </Col>
            </Row>
          </Card>


          {/* داستان ما Section - Professional Timeline Design */}
          <Card 
            className="light-glass-effect-card shaped-border"
            style={{ 
              marginBottom: 32,
              background: "linear-gradient(135deg, rgba(162,56,84,0.15) 0%, rgba(255,255,255,0.05) 100%)",
              border: "1px solid rgba(162,56,84,0.2)",
              backdropFilter: "blur(10px)",
              position: "relative",
              overflow: "hidden"
            }}
          >
            {/* Decorative elements */}
            <div style={{ 
              position: "absolute", 
              top: -100, 
              right: -100, 
              width: 300, 
              height: 300, 
              background: "radial-gradient(circle, rgba(162,56,84,0.15) 0%, transparent 70%)", 
              borderRadius: "50%" 
            }} />
            <div style={{ 
              position: "absolute", 
              bottom: -100, 
              left: -100, 
              width: 250, 
              height: 250, 
              background: "radial-gradient(circle, rgba(240,147,251,0.1) 0%, transparent 70%)", 
              borderRadius: "50%" 
            }} />
            
            <div style={{ position: "relative", zIndex: 2, padding: "20px 20px 40px" }}>
              
              {/* Section Header */}
              <div style={{ textAlign: "center", marginBottom: 48 }}>
                <Divider style={{ borderColor: '#a23854', marginBottom: 20 }}>
                  <Title level={2} style={{ color: '#a23854', fontFamily: 'Yekan', margin: 0, letterSpacing: -1 }}>
                    داستان ما
                  </Title>
                </Divider>
                <Text style={{ color: 'rgb(74, 74, 74)', fontFamily: 'Yekan', fontSize: 16 }}>
                  مسیری پرافتخار از خلاقیت تا خلق آثار ماندگار
                </Text>
              </div>


              {/* Timeline - Mobile Version */}
              <div style={{ display: { xs: 'block', md: 'none' } }}>
                {timelineEvents.map((event, index) => (
                  <div key={index} style={{ marginBottom: 32, position: 'relative', paddingRight: 10 }}>
                    {/* Vertical line */}

                    
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: 16 }}>
                      <div style={{
                        width: 56,
                        height: 56,
                        minWidth: 56,
                        background: `linear-gradient(135deg, ${index % 2 === 0 ? '#a23854' : '#f093fb'}, ${index % 2 === 0 ? '#c74b6e' : '#f5576c'})`,
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxShadow: '0 4px 16px rgba(162,56,84,0.3)',
                        marginTop:"30px"
                      }}>
                        <div style={{ fontSize: 24, color: 'white' }}>
                          {event.icon}
                        </div>
                      </div>
                      
                      <div style={{
                        flex: 1,
                        background: 'linear-gradient(135deg, rgba(162,56,84,0.2), rgba(240,147,251,0.1))',
                        backdropFilter: 'blur(10px)',
                        borderRadius: 16,
                        padding: '16px',
                        border: '1px solid rgba(255,100,100,0.1)'
                      }}>
                        <div style={{
                          fontFamily: 'Yekan',
                          fontSize: 18,
                          fontWeight: 'bold',
                          color: index % 2 === 0 ? '#a23854' : '#f093fb',
                          marginBottom: 4
                        }}>
                          {event.year}
                        </div>
                        <Title level={5} style={{ color: 'rgb(30, 30, 30)', fontFamily: 'Yekan', marginBottom: 8, fontSize: 16 }}>
                          {event.title}
                        </Title>
                        <Text style={{ color: 'rgb(74, 74, 74)', fontFamily: 'Yekan', fontSize: 12 }}>
                          {event.description}
                        </Text>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Journey Highlight */}
              <div style={{ 
                marginTop: 48,
                textAlign: 'center',
                padding: '24px',
                background: 'linear-gradient(135deg, rgba(162,56,84,0.2), rgba(240,147,251,0.1))',
                borderRadius: 24,
                border: '1px solid rgba(162,56,84,0.3)'
              }}>
                <Text style={{ color: 'rgba(0,0,0,0.9)', fontFamily: 'Yekan', fontSize: 14, lineHeight: 1.8 }}>
                  از یک ایده ساده تا خلق هزاران اثر منحصربه‌فرد، ما در کنار شما هستیم تا خلاقیت‌تان را به بهترین شکل به تصویر بکشید.
                  <br />
                  <span style={{ color: '#a23854', fontWeight: 'bold' }}>کیفیت، اعتماد و خلاقیت</span> - سه اصل اساسی در مسیر ما.
                </Text>
              </div>
            </div>
          </Card>

          
          {/* Why Choose Us */}
          <div style={{ marginBottom: 32 }}>
            <Divider orientation="center" style={{ borderColor: 'white' }}>
              <Title level={3} style={{ color: 'white', fontFamily: 'Yekan' }}>
                چرا ما را انتخاب کنید؟
              </Title>
            </Divider>
            
            <Row gutter={[24, 24]} justify="center">
              {whyChooseUs.map((item, index) => (
                <Col xs={24} sm={12} key={index}>
                  <Card 
                    className="shaped-border"
                    style={{ 
                      height: "100%", 
                      textAlign: "center",
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                      cursor: "pointer",
                      background: item.gradient,
                      border: "1px solid rgb(100,30,30)",
                      color: "white"
                    }}
                    hoverable
                    bodyStyle={{ padding: "30px 20px" }}
                  >
                    <div style={{ fontSize: 44, marginBottom: 16, color: "white" }}>
                      {item.icon}
                    </div>
                    <Title level={4} style={{ color: "white", fontFamily: 'Yekan', marginBottom: 12 }}>
                      {item.title}
                    </Title>
                    <Paragraph style={{ marginBottom: 0, color: "rgba(255,255,255,0.9)", fontFamily: 'Yekan', fontSize: 14 }}>
                      {item.description}
                    </Paragraph>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>

          {/* Services Section */}
          <Card 
            className="light-glass-effect-card shaped-border"
            style={{ marginBottom: 32, background: "rgba(255,255,255,0.05)" }}
          >
            <Divider orientation="center" style={{ borderColor: '#a23854' }}>
              <Title level={3} style={{ color: '#a23854', fontFamily: 'Yekan' }}>
                خدمات ما
              </Title>
            </Divider>
            
            <Row gutter={[24, 24]}>
              {services.map((item, index) => (
                <Col xs={24} sm={12} key={index}>
                  <div style={{ 
                    display: "flex", 
                    alignItems: "flex-start", 
                    gap: "16px", 
                    padding: "16px",
                    background: "rgba(162,56,84,0.05)",
                    borderRadius: "16px",
                    transition: "all 0.3s ease",
                    height: "100%"
                  }}
                  className="service-card-hover"
                  >
                    <div style={{ 
                      fontSize: 32, 
                      color: '#a23854',
                      background: "rgba(162,56,84,0.1)",
                      borderRadius: "12px",
                      padding: "12px",
                      minWidth: 56,
                      textAlign: "center"
                    }}>
                      {item.icon}
                    </div>
                    <div>
                      <Title level={5} style={{ fontFamily: 'Yekan', marginBottom: 8, color: '#333' }}>
                        {item.title}
                      </Title>
                      <Text style={{ color: '#666', fontSize: 13, fontFamily: 'Yekan', lineHeight: 1.6 }}>
                        {item.description}
                      </Text>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Card>

          {/* Statistics Section - Updated with gradients matching why choose us */}
          <Row gutter={[16, 16]} style={{ marginBottom: 32 }}>
            {stats.map((item, index) => (
              <Col xs={12} sm={6} key={index}>
                <Card 
                  className="shaped-border" 
                  style={{ 
                    textAlign: "center",
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    background: item.gradient,
                    border: "1px solid rgb(100,30,30)",
                    cursor: "pointer"
                  }}
                  hoverable
                  bodyStyle={{ padding: "20px 10px" }}
                >
                  <div style={{ fontSize: 36, color: "rgba(255,255,255,0.9)", marginBottom: 8 }}>
                    {item.icon}
                  </div>
                  <Title level={2} style={{ fontFamily: 'Yekan', marginBottom: 4, color: "white", fontSize: "1.8rem", margin: 0 }}>
                    {item.number}
                  </Title>
                  <Text style={{ color: "rgba(255,255,255,0.85)", fontFamily: 'Yekan', fontSize: 13 }}>{item.label}</Text>
                </Card>
              </Col>
            ))}
          </Row>

          {/* CTA Section */}
          <Card 
            className="light-glass-effect-card shaped-border"
            style={{ 
              textAlign: "center",
              background: "linear-gradient(135deg, rgba(162,56,84,0.1) 0%, rgba(255,255,255,0.05) 100%)",
              border: "1px solid rgba(162,56,84,0.2)"
            }}
          >
            <HeartOutlined style={{ fontSize: 48, color: '#a23854', marginBottom: 16 }} />
            <Title level={3} style={{ color: '#a23854', fontFamily: 'Yekan' }}>
              آماده سفارش‌دهی هستید؟
            </Title>
            <Paragraph style={{ marginBottom: 24, fontFamily: 'Yekan', fontSize: 15, color: '#666' }}>
              همین حالا با مشاوران ما تماس بگیرید یا طرح خود را از طریق سایت ثبت کنید
            </Paragraph>
            <Row justify="center" gutter={[16, 16]}>
              <Col>
                <Button 
                  href="/choose-product"
                  
                  size="large"
                  style={{ 
                    background: '#a23854',
                    borderColor: '#a23854',
                    borderRadius: 12,
                    minWidth: 160,
                    height: 48,
                    fontFamily: 'Yekan',
                    fontSize: 16,
                    textDecorationLine:"none"
                  }}
                >
              شروع سفارش 
                </Button>
              </Col>
              <Col>
                <Button 
                  size="large"
                  
                  href="/contact-us"
                  style={{ 
                    borderColor: '#a23854',
                    color: '#a23854',
                    borderRadius: 12,
                    minWidth: 160,
                    height: 48,
                    fontFamily: 'Yekan',
                    fontSize: 16,
                    textDecorationLine:"none"
                  }}
                  >
                  تماس با ما 
                </Button>
              </Col>
            </Row>
          </Card>

        </Col>
      </Row>

      <style jsx>{`
        .service-card-hover {
          transition: all 0.3s ease;
        }
        .service-card-hover:hover {
          transform: translateX(-5px);
          background: rgba(162,56,84,0.1) !important;
        }
        
        .timeline-node {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        
        .timeline-node:hover {
          transform: scale(1.1);
          box-shadow: 0 12px 40px rgba(162,56,84,0.4);
        }
        
        .timeline-card {
          transition: all 0.3s ease;
        }
        
        .timeline-card:hover {
          transform: translateY(-4px);
          background: rgba(255,255,255,0.1);
          border-color: rgba(162,56,84,0.3);
        }
      `}</style>
    </div>
  );
};

export default AboutUs;